import Variables from './Variables';

export default Variables;
